import axios from '@/libs/api.request'

export const rideBillingList = (params) => {
  return axios.request({
    url: 'ride-billing/admin/strategies',
    method: 'get',
    params,
  })
}

export const rideBillingGet = (id) => {
  return axios.request({
    url: `ride-billing/admin/strategies/${id}`,
    method: 'get',
  })
}

export const rideBillingCreate = (data) => {
  return axios.request({
    url: 'ride-billing/admin/strategies',
    method: 'post',
    data,
  })
}

export const rideBillingUpdate = (id, data) => {
  return axios.request({
    url: `ride-billing/admin/strategies/${id}`,
    method: 'put',
    data,
  })
}

export const rideBillingDelete = (id) => {
  return axios.request({
    url: `ride-billing/admin/strategies/${id}`,
    method: 'delete',
  })
}
